import { useState, useEffect } from "react";
import { useInView } from 'react-intersection-observer';

const cleanStyles = {
  filter: 'blur(0)',
  transition: 'filter 0.1s'
}

const lowResStyles = {
  filter: 'blur(10px)',
  transition: 'filter 0.1s'
};

/*
 * progressive image hook
 *
 * @param {object} mediaItem: media object returned from shopify storefront api 
 *                 (see middleware product controller)
 *                 should contain multiple urls of different standard sizes
 * @param {string} mediaSize: desired size to use as high res image
 *
 * @return {object} contains image src to use as well as extra styles to add to image
 */
export default function useProgressiveImg ({ mediaItem, mediaSize }) {
  const loadHighResImage = (inView, entry) => {
    if (inView) {
      // create new image with high res source
      const img = new Image();
      img.src = highQualitySrc;
      // once high res source is loaded, ship it
      img.onload = () => {
        setSrc(highQualitySrc);        
        setBlurStyles(cleanStyles);
      };
    }
  }

  const { ref, inView, entry } = useInView({
    onChange: loadHighResImage,
    triggerOnce: true,
  });

  const lowQualitySrc = mediaItem.thumbnailUrl;
  const highQualitySrc = Object.hasOwn(mediaItem, `${mediaSize}Url`)
    ? mediaItem[`${mediaSize}Url`]
    : mediaItem['url'];

  const [src, setSrc] = useState();
  const [blurStyles, setBlurStyles] = useState(lowResStyles);

  useEffect(() => {
    setSrc(lowQualitySrc);
  }, []);

  return {
    ref,
    inView,
    entry,
    src,
    blurStyles
  };
};
